import { FC, useCallback, useState, useRef } from 'react';
import { RiskDetailsInfoPopup } from '@/components';
import { RiskType } from '@/models';
import { getSignalTranslation } from '@/helpers';
import { Popover } from 'antd';
import styles from './RiskDetailsInfoItem.module.sass';

interface RiskDetailsInfoItemProps {
  type: RiskType;
  value: number;
  price: string;
  label: string;
}

const RiskDetailsInfoItem: FC<RiskDetailsInfoItemProps> = ({
  type,
  value,
  price,
  label,
}) => {
  const [showDetails, setShowDetails] = useState(false);

  const handleOnToggleDetails = useCallback(() => {
    setShowDetails(() => !showDetails);
  }, [showDetails]);

  const handleOnCloseDetails = useCallback(() => {
    setShowDetails(() => false);
  }, []);

  const titleRef = useRef(null);

  return (
    <div className={styles.item}>
      <div className={styles.inner}>
        <div className={styles.value}>{value}%</div>
        <div
          className={styles.title}
          onClick={handleOnToggleDetails}
          ref={titleRef}
        >
          {getSignalTranslation(label)}
          <Popover
            open={showDetails}
            content={
              <RiskDetailsInfoPopup
                type={type}
                value={value}
                label={label}
                price={price}
                parentRef={titleRef}
                onClose={handleOnCloseDetails}
              />
            }
          />
        </div>
        <div className={styles.dash} />
        <div className={styles.cash}>{price}</div>
        <div className={styles.level} style={{ width: `${value}%` }} />
      </div>
    </div>
  );
};

export default RiskDetailsInfoItem;
